/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';


export interface QuotePriceListsControllerRemoveByCategory$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The quote ID.
 */
  quoteId: string;

/**
 * The category ID.
 */
  categoryId: string;
}

export function quotePriceListsControllerRemoveByCategory(http: HttpClient, rootUrl: string, params: QuotePriceListsControllerRemoveByCategory$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<{
'deletedCount'?: number;
}>> {
  const rb = new SalesRequestBuilder(rootUrl, quotePriceListsControllerRemoveByCategory.PATH, 'delete');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.query('quoteId', params.quoteId, {});
    rb.query('categoryId', params.categoryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<{
      'deletedCount'?: number;
      }>;
    })
  );
}

quotePriceListsControllerRemoveByCategory.PATH = '/o2-sales/quote-price-lists/{tenant}/category/by-quote';
